<template>
    <v-container>
        <v-card>
            <v-card-title>Historial de Beneficios</v-card-title>
            <v-card-text>
                <!-- <VueApexCharts type="line" height="350" :options="chartOptions" :series="series"></VueApexCharts> -->
                <apexchart type="line" height="350" :options="chartOptions" :series="series"></apexchart>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
export default {
    name: 'AutoBotDashboardComponent',
    components: {
    },
    data() {
        return {
            series: [{
                name: 'Beneficios',
                data: [10, 41, 35, 51, 49, 62, 69, 91, 148]
            }],
            chartOptions: {
                chart: {
                    height: 350,
                    type: 'line',
                    zoom: {
                        enabled: false
                    }
                },
                colors: ['#008FFB'],
                // dataLabels: {
                //     enabled: false
                // },
                stroke: {
                    curve: 'straight'
                },
                title: {
                    text: 'Beneficios por Mes',
                    align: 'left'
                },
                grid: {
                    row: {
                        // colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                        opacity: 0.5
                    },
                },
                xaxis: {
                    categories: ['Enero', 'Febrero', 'Marzo', 'Abril',
                        'Mayo', 'Junio', 'Julio', 'Agosto',
                        'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
                },
                tooltip: {
                    enabled: true,
                    enabledOnSeries: undefined,
                    shared: true,
                    followCursor: false,
                    intersect: false,
                    inverseOrder: false,
                    custom: undefined,
                    hideEmptySeries: true,
                    fillSeriesColor: false,
                    theme: 'dark',
                    style: {
                        fontSize: '12px',
                        fontFamily: undefined
                    },
                    onDatasetHover: {
                        highlightDataSeries: false,
                    },
                    x: {
                        show: true,
                        format: 'dd MMM',
                        formatter: undefined,
                    },
                    y: {
                        formatter: undefined,
                        title: {
                            formatter: (seriesName) => seriesName,
                        },
                    },
                    z: {
                        formatter: undefined,
                        title: 'Size: '
                    },
                    marker: {
                        show: true,
                    },
                    items: {
                        // display: flex,
                    },
                    fixed: {
                        enabled: false,
                        position: 'topRight',
                        offsetX: 0,
                        offsetY: 0,
                    },
                },
                theme: {
                    mode: 'dark',
                    palette: 'palette9'
                }
            },

        };
    },
    computed: {},
    created() { },
    mounted() {
        // console.log(this.chart)

    },
    methods: {
        loadData(value) {
            // console.log(value)
            // console.log(this.series[0].data)
            let beneficios = []
            for (let index = 0; index < value.length; index++) {
                beneficios.push(value[index].beneficios.toFixed(2))
            }
            // console.log(beneficios)
            this.series = [{
                data: beneficios
            }]
            // this.series.data = value
        },
        updateData() {
            console.log("Actualizar datos");
        },
        // initData(value, isAdmin, isActive) {
        //     this.idBot = value
        //     this.isAdmin = isAdmin
        //     this.isActive = isActive
        //     UserService.getStatusBot(this.idBot).then(
        //         response => {
        //             if (response.data === 'NOT INIT') {
        //                 UserService.getBot(this.idBot).then(
        //                     response => {
        //                         console.log(response.data)
        //                         this.bot = response.data
        //                         this.isAutomatic = this.bot.automatico
        //                         this.start = false
        //                         this.msgBtn = 'START'
        //                         this.colors = 'success'
        //                     }
        //                 );
        //             } else {
        //                 this.loadData(response.data, isAdmin);
        //             }
        //         },
        //         error => {
        //             this.content =
        //                 (error.response && error.response.data && error.response.data.message) ||
        //                 error.message ||
        //                 error.toString();
        //             if (error.response && error.response.status === 403) {
        //                 EventBus.dispatch("logout");
        //             }
        //         }
        //     );
        // },
        // loadData(data, isAdmin) {
        //     if (data !== 'NOT INIT') {
        //         // console.log(data.bot.pair)
        //         this.bot = data.bot;
        //         this.isAutomatic = this.bot.automatico
        //         this.$refs.chart.loadDataSets(this.bot.id, isAdmin)
        //         this.titleOrders = this.bot.pair;
        //         let arrayPairs = this.bot.pair.split("-");
        //         this.pair1 = arrayPairs[0];
        //         this.pair2 = arrayPairs[1];
        //         this.initDate = data.start_time
        //         this.available = data.available
        //         this.market1 = data.market1_balance
        //         this.startPrice = data.start_price
        //         this.currentPrice = data.currentPrice
        //         this.fees = data.fees
        //         this.profits = data.profits
        //         if (this.bot.started === false) {
        //             this.start = false
        //             this.msgBtn = 'START'
        //             this.colors = 'success'
        //         } else {
        //             this.start = true
        //             this.msgBtn = 'STOP'
        //             this.colors = 'error'
        //         }
        //     } else {
        //         this.start = false
        //         this.msgBtn = 'START'
        //         this.colors = 'success'
        //     }
        // },
        // statusBot() {
        //     if (this.start === false) {
        //         this.start = true
        //         this.msgBtn = 'STOP'
        //         this.colors = 'error'
        //         // Iniciar bot
        //         this.sendStatus(true)
        //     } else {
        //         this.start = false
        //         this.msgBtn = 'START'
        //         this.colors = 'success'
        //         // Parar bot
        //         this.pauseBot(false)
        //     }
        // },
        // sendStatus(status) {
        //     this.message = ''
        //     this.submitted = true
        //     this.bot.started = status
        //     if (this.isAutomatic) {
        //         UserService.postStatusBotAuto(this.bot).then(
        //             response => {
        //                 this.idBot = response.bot.id
        //                 this.initData(this.idBot, this.isAdmin, this.isActive)
        //                 setTimeout(() => (this.responseChangeStartedBot('success', 'INICIAR BOT', 'Bot iniciado!!!')), 1000)
        //             },
        //             error => {
        //                 this.content =
        //                     (error.response && error.response.data && error.response.data.message) ||
        //                     error.message ||
        //                     error.toString()
        //                 setTimeout(() => (this.responseChangeStartedBot('error', 'INICIAR BOT', this.msgError)), 1000)
        //             }
        //         )
        //     } else {
        //         UserService.postStatusBot(this.bot).then(
        //             response => {
        //                 this.idBot = response.bot.id
        //                 this.initData(this.idBot, this.isAdmin, this.isActive)
        //                 setTimeout(() => (this.responseChangeStartedBot('success', 'INICIAR BOT', 'Bot iniciado!!!')), 1000)
        //             },
        //             error => {
        //                 this.content =
        //                     (error.response && error.response.data && error.response.data.message) ||
        //                     error.message ||
        //                     error.toString()
        //                 setTimeout(() => (this.responseChangeStartedBot('error', 'INICIAR BOT', this.msgError)), 1000)
        //             }
        //         )
        //     }

        // },
        // pauseBot(status) {
        //     this.message = ''
        //     this.submitted = true
        //     this.bot.started = status
        //     UserService.pauseBot(this.bot).then(
        //         response => {
        //             this.idBot = response.id
        //             this.initData(this.idBot, this.isAdmin, this.isActive)
        //             setTimeout(() => (this.responseChangeStartedBot('success', 'PARAR BOT', 'Bot parado!!!')), 1000)
        //         },
        //         error => {
        //             this.content =
        //                 (error.response && error.response.data && error.response.data.message) ||
        //                 error.message ||
        //                 error.toString()
        //             setTimeout(() => (this.responseChangeStartedBot('error', 'PARAR BOT', this.msgError)), 1000)
        //         }
        //     );
        // },
        // responseChangeStartedBot(response, title, msg) {
        //     this.$refs.dialogMessages.openModal()
        //     this.$refs.dialogMessages.component = 'CHANGE STARTED BOT'
        //     this.$refs.dialogMessages.tituloDialog = title
        //     this.$refs.dialogMessages.msgError = msg
        //     this.$refs.dialogMessages.isShow = true
        //     if (response === 'success') {
        //         this.$refs.dialogMessages.types = 'success'
        //         this.successful = true
        //     } else {
        //         this.$refs.dialogMessages.types = 'error'
        //         this.successful = false
        //     }
        // },
    }
}
</script>
